/* eslint-disable class-methods-use-this */
class ComparisonTable extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.quiz = this.closest('onboarding-quiz');
    this.urlDiscountCode = this.#getUrlDiscountCode();
    this.#addEventListeners();
  }

  #addEventListeners() {
    this.querySelector('.back-button').addEventListener('click', () => {
      this.quiz.moveToStart();
    });

    this.querySelector('.back-button').addEventListener('click', () => {
      this.quiz.moveToStart();
    });

    const buttons = this.querySelectorAll('.table-product__add-to-cart-button');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const product = button.closest('.table-product');

        this.selectedVariant = product.dataset.variantId;
        this.selectedDiscount = this.urlDiscountCode || product.dataset.discountCode;
        this.selectedSellingPlan = product.dataset.sellingPlanId;
        this.nextProductVariantId = product.dataset.nextProductVariant;

        this.#fireEvent("box_selected", product.dataset.boxName);
        if (this.quiz.getAttribute('data-include-frequency') == "true") {
          this.#showFrequencyStep();
          this.#fireEvent("step_viewed", "step_3_frequency");
        } else {
          this.#addToCart(button);
        }
      });
    });
  }

  /**
   * Gets discount code from URL query parameter if it has the CGC- prefix
   * @returns {string|null} The discount code if valid, null otherwise
   */
  #getUrlDiscountCode() {
    const urlParams = new URLSearchParams(window.location.search);
    const discountCode = urlParams.get('discount_code') || urlParams.get('discount');

    if (discountCode && discountCode.toUpperCase().startsWith('CGC-')) {
      return discountCode.toUpperCase();
    }

    return null;
  }

  #showFrequencyStep() {
    const frequencyBlock = this.quiz.querySelector(`onboarding-frequency[data-step="frequency_${this.selectedVariant}"]`);
    this.classList.add("hidden");
    frequencyBlock.classList.remove("hidden");
    frequencyBlock.dataset.from = this.dataset.step;
    window.dispatchEvent(new CustomEvent('change-checkout-step', { detail: { step: 3 } }));
  }

  async #addToCart(thisButton) {
    if (!this.selectedVariant || !this.selectedSellingPlan) {
      return;
    }

    thisButton.setAttribute('disabled', 'disabled');
    thisButton.classList.add('loading');
    thisButton.querySelector('.loading__spinner').classList.remove('hidden');

    try {
      const signupConfig = {
        mainProduct: {
          variantId: this.selectedVariant,
          sellingPlanId: this.selectedSellingPlan,
        },
        ...this.nextProductVariantId ? {nextProduct: {variantId: this.nextProductVariantId}} : {},
        discountCode: this.selectedDiscount,
      };

      const subscriptionCart = new SubscriptionCart();
      await subscriptionCart.checkout(signupConfig, true);
    } catch (error) {
      console.log('Error adding to cart:', error);
    } finally {
      thisButton.removeAttribute('disabled');
      thisButton.classList.remove('loading');
      thisButton.querySelector('.loading__spinner').classList.add('hidden');
    }
  }

  #fireEvent(eventAction, eventValue) {
    window.dataLayer.push({
      event: 'site_interaction',
      context: 'quiz_selection',
      action: eventAction,
      value: eventValue
    });
  }
}

if (!customElements.get('comparison-table')) {
  window.customElements.define('comparison-table', ComparisonTable);
}
